import TopHeader from "./topheader/Topheader";
import Navbar from './Navbar/Navbar';

function Header(){
    return(
    <>
        <TopHeader />
        <Navbar />
    </>
    )
}

export default Header;